import PropTypes from "prop-types"
import { useT } from "react-polyglot-hooks"
import styled from "styled-components"
import Typography from "components/styled/Typography"
import Image from "next/legacy/image"

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  small {
    margin-right: 5px;
  }
`

function OnlineScoring({ white }) {
  const t = useT()

  return (
    <Wrapper>
      <Typography variant="small" color={white ? "white" : null}>
        {t("car.online_scoring")}
      </Typography>
      <Image alt="Chrono" height={24} width={24} src={`/f_svg/static/chrono${white ? "_white" : ""}`} />
    </Wrapper>
  )
}

OnlineScoring.defaultProps = {
  white: false
}

OnlineScoring.propTypes = {
  white: PropTypes.bool
}

export default OnlineScoring
